import ToolShell, { OutputBlock } from "@/pages/tools/ToolShell";

export default function CoursePromo() {
  return (
    <ToolShell
      testid="tool-course-page" eyebrow="Pro Tool" toolKey="course" title="Course Promo Builder"
      subtitle="A full launch pack for a single diving course - caption, reel, stories, email, carousel."
      endpoint="/tools/course-promo" tier="pro" transformPayload={(s) => ({ brief: s })}
      fields={[
        { key: "course_name", label: "Course name", type: "text", required: true, placeholder: "e.g. PADI Advanced Open Water - October weekend intensive" },
        { key: "course_url", label: "Course page URL (optional)", type: "text", placeholder: "https://your-centre.com/courses/aow", help: "If provided, we'll read the page and pull real dates, prices and modules." },
        { key: "price", label: "Price (EUR)", type: "text" },
        { key: "dates", label: "Dates / availability", type: "text" },
        { key: "transformation", label: "The transformation", type: "textarea", rows: 3, placeholder: "From → to in this course" },
        { key: "objections", label: "Common objections you hear (optional)", type: "textarea", rows: 3 },
      ]}
      renderOutput={(o) => (
        <>
          <OutputBlock label="Positioning">{o.positioning_statement}</OutputBlock>
          <OutputBlock label="Audience">{o.audience}</OutputBlock>
          <OutputBlock label="Transformation">{o.transformation}</OutputBlock>
          <OutputBlock label={`Instagram caption (${(o.instagram_caption || "").length} chars)`} copyValue={o.instagram_caption}>
            <div className="whitespace-pre-wrap leading-relaxed">{o.instagram_caption}</div>
          </OutputBlock>
          {o.reel_concept && (
            <OutputBlock label="Reel concept">
              <div className="space-y-2 text-[14.5px]">
                <div><span className="dms-label">Archetype</span><div>{o.reel_concept.hook_archetype}</div></div>
                <div><span className="dms-label">Hooks</span><ul className="mt-1 list-disc pl-5">{(o.reel_concept.hooks || []).map((h, i) => <li key={i}>&ldquo;{h}&rdquo;</li>)}</ul></div>
                <div><span className="dms-label">Structure</span><div>{o.reel_concept.structure}</div></div>
                <div><span className="dms-label">CTA</span><div>{o.reel_concept.cta}</div></div>
              </div>
            </OutputBlock>
          )}
          {o.story_sequence && <OutputBlock label="Story sequence"><ol className="list-decimal pl-5 space-y-1">{o.story_sequence.map((s, i) => <li key={i}>{s}</li>)}</ol></OutputBlock>}
          {o.email_promo && (
            <OutputBlock label="Email promo">
              <div className="space-y-2"><div><span className="dms-label">Subject</span><div className="font-semibold">{o.email_promo.subject}</div></div><div><span className="dms-label">Body</span><div className="whitespace-pre-wrap leading-relaxed mt-1">{o.email_promo.body}</div></div><div><span className="dms-label">CTA</span><div>{o.email_promo.cta}</div></div></div>
            </OutputBlock>
          )}
          {o.carousel_outline && <OutputBlock label="Carousel outline"><ol className="list-decimal pl-5 space-y-1">{o.carousel_outline.map((s, i) => <li key={i}>{s}</li>)}</ol></OutputBlock>}
          {o.lead_magnet_idea && <OutputBlock label="Lead magnet idea">{o.lead_magnet_idea}</OutputBlock>}
          {o.objection_responses && (
            <OutputBlock label="Objection responses">
              <div className="space-y-3">{o.objection_responses.map((r, i) => (<div key={i}><div className="font-semibold text-[#0A2342]">{r.objection}</div><div className="text-[#475569] mt-1">{r.response}</div></div>))}</div>
            </OutputBlock>
          )}
        </>
      )}
    />
  );
}
